import { render, staticRenderFns } from "./Politica_Privacidad.vue?vue&type=template&id=20ccd9c6&"
import script from "./Politica_Privacidad.vue?vue&type=script&lang=js&"
export * from "./Politica_Privacidad.vue?vue&type=script&lang=js&"
import style0 from "./Politica_Privacidad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCard,VCardText,VCardTitle,VContainer,VFlex,VIcon,VLayout})
